import React, { useMemo } from 'react';
import { node, shape, arrayOf, string } from 'prop-types';
import OATProvider from './oat-provider';
import { getItem } from '../../utils/storage';

const OATWrapper = ({
  data: {
    menus,
    errorList = {
      frontmatter: {
        errors: [],
      },
    },
  },
  children,
}) => {
  const itemImages = useMemo(() => {
    const pricedMenus = menus?.pricedMenus.flatMap((menu) => menu.items);

    return pricedMenus;
  }, [menus]);

  const {
    frontmatter: { errors },
  } = errorList;

  const initialStorage = getItem();

  return (
    <OATProvider errors={errors} initialStorage={initialStorage} itemImages={itemImages}>
      {children}
    </OATProvider>
  );
};

OATWrapper.propTypes = {
  data: shape({
    errorList: shape({
      frontmatter: shape({
        errors: arrayOf(
          shape({
            code: string.isRequired,
            message: string.isRequired,
          })
        ).isRequired,
      }).isRequired,
    }),
  }).isRequired,
  children: node.isRequired,
};

export default OATWrapper;
